module.exports = __webpack_public_path__ + "img/passenger.a643df33.svg";